export const SOCKET_CONNECT = '@@socket/CONNECT';
export const SOCKET_SUBSCRIBE = '@@socket/SUBSCRIBE';
export const SOCKET_UNSUBSCRIBE = '@@socket/UNSUBSCRIBE';

export const SOCKER_CONNECTION_ERROR = '@@socket/CONNECTION_ERROR';

/**
 *  CONNECT: Expected payload:
 *  {
 *      url: string,
 *  }
 **/
export function socketConnect(payload) {
    return { type: SOCKET_CONNECT, payload };
}

/**
 *  SUBSCRIBE: Expected payload:
 *  {
 *      channel: string,
 *      query: string,
 *      onMessage: func,
 *      onError: func,
 *  }
 **/
export function socketSubscribe(payload) {
    return { type: SOCKET_SUBSCRIBE, payload };
}

/**
 *  UNSUBSCRIBE: Expected payload:
 *  {
 *      channel: string
 *  }
 **/
export function socketUnsubscribe(payload) {
    return { type: SOCKET_UNSUBSCRIBE, payload };
}

/**
 * CONNECTION_ERROR: Expected payload:
 * {
 *    error: string
 * }
 */

export function socketConnectionError(payload) {
    return { type: SOCKER_CONNECTION_ERROR, payload };
}



/** WEBPACK FOOTER **
 ** /src/shared/actions/socket.js
 **/